var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Base } from "../base";
import { Header } from "./header";
import { ChatArea } from "./chat-area";
import { InputArea } from "./input-area";
import { Footer } from "./footer";
import { ViewType } from "../../models/view-type";
var ChatWindow = /** @class */ (function (_super) {
    __extends(ChatWindow, _super);
    function ChatWindow(configuration, viewType, apiSendMessageAction, parseMarkdownAction, maximizeWindowAction, minimizeWindowAction, hideChat) {
        var _this = _super.call(this) || this;
        _this._isSending = false;
        _this.maximizeWindow = function () {
            _this._viewType = ViewType.DesktopLarge;
            _this._chatArea.setFullSizeWindow(_this._viewType);
            _this._inputArea.setFullSizeWindow();
            _this._maximizeWindowAction();
        };
        _this.minimizeWindow = function () {
            _this._viewType = ViewType.DesktopSmall;
            _this._chatArea.setSmallSizeWindow();
            _this._inputArea.setSmallSizeWindow();
            _this._minimizeWindowAction();
        };
        _this.sendMessage = function () { return __awaiter(_this, void 0, void 0, function () {
            var value, viewType, isMobile, messageResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        value = this._inputArea.getValue();
                        if (this._isSending || !this.isValueValid(value)) {
                            return [2 /*return*/];
                        }
                        viewType = this._viewType;
                        isMobile = viewType === ViewType.MobileSmall || viewType === ViewType.MobileLarge;
                        this._isSending = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 6, 7]);
                        return [4 /*yield*/, this._chatArea.addUserMessage(value, viewType)];
                    case 2:
                        _a.sent();
                        this._inputArea.clearValue();
                        return [4 /*yield*/, this._chatArea.addEmptyAssistantMessage(viewType)];
                    case 3:
                        _a.sent();
                        this._inputArea.disable(isMobile);
                        return [4 /*yield*/, this._apiSendMessageAction(value)];
                    case 4:
                        messageResponse = _a.sent();
                        return [4 /*yield*/, this._chatArea.addTextToLastAssistantMessage(messageResponse ? messageResponse.result.result_text : "".concat(process.env.AIGO_CHAT_ERROR_MESSAGE), viewType)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        this._isSending = false;
                        this._inputArea.enable();
                        if (!isMobile) {
                            this._inputArea.focus();
                        }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        _this.isValueValid = function (value) {
            if (value && value.length > 0) {
                var trimmedValue = value.trim();
                return trimmedValue.length > 0;
            }
            return false;
        };
        _this._apiSendMessageAction = apiSendMessageAction;
        _this._minimizeWindowAction = minimizeWindowAction;
        _this._maximizeWindowAction = maximizeWindowAction;
        _this._viewType = viewType;
        _this._header = new Header(configuration, viewType, _this.maximizeWindow, _this.minimizeWindow, hideChat);
        _this._chatArea = new ChatArea(configuration, viewType, parseMarkdownAction);
        _this._inputArea = new InputArea(configuration, viewType, _this.sendMessage);
        _this._footer = new Footer(configuration);
        var chatWindow = document.createElement('div');
        chatWindow.id = 'js_aigo_bot_chat_window';
        chatWindow.style.backgroundColor = configuration.backgroundColor;
        chatWindow.style.boxShadow = '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)';
        if (viewType === ViewType.MobileSmall || viewType === ViewType.MobileLarge) {
            chatWindow.style.display = 'flex';
            chatWindow.style.flexDirection = 'column';
            chatWindow.style.height = '100%';
            chatWindow.style.overflow = 'hidden';
            _this._header.self.style.flexShrink = '0';
        }
        chatWindow.appendChild(_this._header.self);
        chatWindow.appendChild(_this._chatArea.self);
        if (viewType === ViewType.MobileSmall || viewType === ViewType.MobileLarge) {
            var bottomSticky = document.createElement('div');
            bottomSticky.style.flexShrink = '0';
            var inputAreaBorder = document.createElement('div');
            inputAreaBorder.style.height = '6px';
            inputAreaBorder.style.backgroundColor = configuration.backgroundColor;
            bottomSticky.appendChild(inputAreaBorder);
            bottomSticky.appendChild(_this._inputArea.self);
            bottomSticky.appendChild(_this._footer.self);
            chatWindow.appendChild(bottomSticky);
        }
        else {
            chatWindow.style.marginTop = '-5px'; // to handle properly rounded corners of the header
            chatWindow.style.borderRadius = '5px';
            chatWindow.appendChild(_this._inputArea.self);
            chatWindow.appendChild(_this._footer.self);
        }
        _this.self = chatWindow;
        return _this;
    }
    ChatWindow.prototype.focus = function () {
        this._header.focus();
    };
    ChatWindow.prototype.show = function () {
        if (this._viewType === ViewType.MobileSmall || this._viewType === ViewType.MobileLarge) {
            this.self.style.display = 'flex';
            return;
        }
        _super.prototype.show.call(this);
    };
    ChatWindow.prototype.scrollToBottom = function () {
        this._chatArea.scrollToBottom();
    };
    return ChatWindow;
}(Base));
export { ChatWindow };
